export enum BonusStatusEnum {
  Active = '1',
  Released = '2', // the wallet was complete and the balance moved to the real balance
  UsedUp = '3', //the player loses the bonus
  Canceled = '4', // canceled either by the player o by the admin
  Expired = '5', // the bonus has reached the expiration date
}
